class ProductGalleryLimit {
  constructor() {
    this.mobileBreakpoint = 750;
    this.initButtons();
    this.handleResize();
  }

  initButtons() {
    const viewAllButtons = document.querySelectorAll('.product__view-all-button');
    
    viewAllButtons.forEach(button => {
      button.addEventListener('click', this.handleViewAllClick.bind(this));
    });
  }

  handleResize() {
    window.addEventListener('resize', () => {
      if (window.innerWidth < this.mobileBreakpoint) {
        const galleries = document.querySelectorAll('media-gallery.show-all-images');
        galleries.forEach(gallery => {
          gallery.classList.remove('show-all-images');
          const button = document.querySelector(`[data-gallery-id="${gallery.id}"]`);
          if (button) {
            const viewAllText = button.querySelector('.view-all-text');
            const viewLessText = button.querySelector('.view-less-text');
            if (viewAllText) viewAllText.classList.remove('hidden');
            if (viewLessText) viewLessText.classList.add('hidden');
          }
        });
      }
    });
  }

  handleViewAllClick(event) {
    if (window.innerWidth < this.mobileBreakpoint) return;

    const button = event.currentTarget;
    const galleryId = button.dataset.galleryId;
    const gallery = document.getElementById(galleryId);
    
    if (!gallery) return;

    const viewAllText = button.querySelector('.view-all-text');
    const viewLessText = button.querySelector('.view-less-text');
    
    gallery.classList.toggle('show-all-images');
    
    if (gallery.classList.contains('show-all-images')) {
      viewAllText.classList.add('hidden');
      viewLessText.classList.remove('hidden');
      
      this.scrollToFirstHiddenImage(gallery);
    } else {
      viewAllText.classList.remove('hidden');
      viewLessText.classList.add('hidden');
      
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToFirstHiddenImage(gallery) {
    setTimeout(() => {
      const hiddenItems = gallery.querySelectorAll('.product__media-item--hidden');
      if (hiddenItems.length > 0) {
        const firstHiddenItem = hiddenItems[0];
        firstHiddenItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductGalleryLimit();
  });
} else {
  new ProductGalleryLimit();
}

document.addEventListener('shopify:section:load', () => {
  new ProductGalleryLimit();
});

